<template>
    <!-- popover -->
    <b-popover :target="'popover-target-zs_' + id" triggers="hover" no-fade placement="top" class="popoverN">
        <template #title>
            <span>指数走势</span>
        </template>
        <template #default>
            <div class="table-responsive fs-sm-5 fs-xl-15 fs-lg-15 fs-md-15">
                <table class="table table-bordered table-sm text-center">
                    <thead>
                        <tr>
                            <th></th>
                            <th colspan="3" scope="col">
                                滚（半场）
                            </th>
                            <th colspan="3" scope="col">即（半场）</th>
                            <th colspan="3" scope="col">初（半场）</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">
                                <b-badge class="profile-badge" variant="light-danger">
                                    亚
                                </b-badge>
                            </th>
                            <td>{{ matchModel.asiaCA1 }}</td>
                            <td>{{ matchModel.asiaHalfGA2 }}</td>
                            <td>{{ matchModel.asiaHalfGA3 }}</td>
                            <td>{{ matchModel.asiaHalfJA1 }}</td>
                            <td>{{ matchModel.asiaHalfJA2 }}</td>
                            <td>{{ matchModel.asiaHalfJA3 }}</td>
                            <td>{{ matchModel.asiaHalfCA1 }}</td>
                            <td>{{ matchModel.asiaHalfCA2 }}</td>
                            <td>{{ matchModel.asiaHalfCA3 }}</td>
                        </tr>
                        <tr>
                            <th scope="row">
                                <b-badge class="profile-badge" variant="light-info">
                                    欧
                                </b-badge>
                            </th>
                            <td>{{ matchModel.ouHalfGA1 }}</td>
                            <td>{{ matchModel.ouHalfGA2 }}</td>
                            <td>{{ matchModel.ouHalfGA3 }}</td>
                            <td>{{ matchModel.ouHalfJA1 }}</td>
                            <td>{{ matchModel.ouHalfJA2 }}</td>
                            <td>{{ matchModel.ouHalfJA3 }}</td>
                            <td>{{ matchModel.ouHalfCA1 }}</td>
                            <td>{{ matchModel.ouHalfCA2 }}</td>
                            <td>{{ matchModel.ouHalfCA3 }}</td>
                        </tr>
                        <tr>
                            <th scope="row">
                                <b-badge class="profile-badge" variant="light-warning">
                                    大
                                </b-badge>
                            </th>
                            <td>{{ matchModel.daHalfGA1 }}</td>
                            <td>{{ matchModel.daHalfGA2 }}</td>
                            <td>{{ matchModel.daHalfGA3 }}</td>
                            <td>{{ matchModel.daHalfJA1 }}</td>
                            <td>{{ matchModel.daHalfJA2 }}</td>
                            <td>{{ matchModel.daHalfJA3 }}</td>
                            <td>{{ matchModel.daHalfCA1 }}</td>
                            <td>{{ matchModel.daHalfCA2 }}</td>
                            <td>{{ matchModel.daHalfCA3 }}</td>
                        </tr>

                    </tbody>
                    <thead>
                        <tr>
                            <th></th>
                            <th colspan="3" scope="col">滚（全场）
                            </th>
                            <th colspan="3" scope="col">即（全场）
                            </th>
                            <th colspan="3" scope="col">初（全场）
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">
                                <b-badge class="profile-badge" variant="light-danger">
                                    亚
                                </b-badge>
                            </th>
                            <td>{{ matchModel.asiaGA1 }}</td>
                            <td>{{ matchModel.asiaGA2 }}</td>
                            <td>{{ matchModel.asiaGA3 }}</td>
                            <td>{{ matchModel.asiaJA1 }}</td>
                            <td>{{ matchModel.asiaJA2 }}</td>
                            <td>{{ matchModel.asiaJA3 }}</td>
                            <td>{{ matchModel.asiaCA1 }}</td>
                            <td>{{ matchModel.asiaCA2 }}</td>
                            <td>{{ matchModel.asiaCA3 }}</td>
                        </tr>
                        <tr>
                            <th scope="row">
                                <b-badge class="profile-badge" variant="light-info">
                                    欧
                                </b-badge>
                            </th>
                            <td>{{ matchModel.ouGA1 }}</td>
                            <td>{{ matchModel.ouGA2 }}</td>
                            <td>{{ matchModel.ouGA3 }}</td>
                            <td>{{ matchModel.ouJA1 }}</td>
                            <td>{{ matchModel.ouJA2 }}</td>
                            <td>{{ matchModel.ouJA3 }}</td>
                            <td>{{ matchModel.ouCA1 }}</td>
                            <td>{{ matchModel.ouCA2 }}</td>
                            <td>{{ matchModel.ouCA3 }}</td>
                        </tr>
                        <tr>
                            <th scope="row">
                                <b-badge class="profile-badge" variant="light-warning">
                                    大
                                </b-badge>
                            </th>
                            <td>{{ matchModel.daGA1 }}</td>
                            <td>{{ matchModel.daGA2 }}</td>
                            <td>{{ matchModel.daGA3 }}</td>
                            <td>{{ matchModel.daJA1 }}</td>
                            <td>{{ matchModel.daJA2 }}</td>
                            <td>{{ matchModel.daJA3 }}</td>
                            <td>{{ matchModel.daCA1 }}</td>
                            <td>{{ matchModel.daCA2 }}</td>
                            <td>{{ matchModel.daCA3 }}</td>
                        </tr>

                    </tbody>

                </table>
            </div>
        </template>
    </b-popover>
</template>
<script>
export default ({
    props: {
        id: {
            type: String,
            default: 'default',
        },
        matchModel: {
            type: Object,
            default: function () {
                return {}
            }
        },
    },

    created() {
       
    },

})
</script>
<style lang="css">
.popover {
    max-width: 600px;
}
/* 针对手机屏幕的媒体查询（小于768px） */  
@media (max-width: 767.98px) {  
    .popover {  
        max-width: 320px;  
    }  
}
</style>